// extracted by mini-css-extract-plugin
export var icon = "_r1-0";